import { useCallback, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function useRedeemMapleKey() {
  const { session } = useAuth();
  const [redeeming, setRedeeming] = useState(false);

  const redeem = useCallback(async (keyValue: string) => {
    const normalizedKey = keyValue.trim();
    if (!normalizedKey || !UUID_PATTERN.test(normalizedKey)) {
      throw new Error('This Maple Key is invalid. Please check the key and try again.');
    }

    if (!session?.access_token) {
      throw new Error('You must be signed in to redeem a Maple Key.');
    }

    setRedeeming(true);
    try {
      const { data, error } = await supabase.functions.invoke('redeem-maple-key', {
        body: { key: normalizedKey },
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      if (error || !data?.ok) {
        throw new Error(error?.message || data?.error || 'Failed to redeem Maple Key.');
      }

      window.dispatchEvent(new CustomEvent('maple-market:licenses-refresh'));
      return data as {
        ok: true;
        message: string;
        productId: string | null;
        sku: string | null;
        licenseId: string | null;
      };
    } finally {
      setRedeeming(false);
    }
  }, [session?.access_token]);

  return {
    redeem,
    redeeming,
  };
}
